export enum EnvironmentDeploy {
    Local = 'Local',
    QA = 'QA',
    Staging = 'Staging',
    Production = 'Production'
}
